import React from "react";
import Transl from "../Components/Transl/Transl";
import Btn from "../Components/Home/Banner/AllBanners/Btn";
import BannerTable from "../Components/Home/Banner/AllBanners/BannerTable";

function Banner() {
  return (
    <div>
      <div className="flex justify-between items-center py-7 px-10">
        <Btn />
      </div>
      <div className="px-10">
        <BannerTable />
      </div>
    </div>
  );
}

export default Banner;
